import React from "react";
import "./links.css";
const InlineLink = ({ text, url }) => {
  return (
    <a href={url} style={{}} className="link">
      {" "}
      {text}{" "}
    </a>
  );
};

export default InlineLink;
